import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Download, FileText, Video, Headphones, Image } from 'lucide-react';

const resourceTypeConfig = {
  comic: { label: 'Bande dessinée', icon: Image, color: 'bg-purple-100 text-purple-700' },
  worksheet: { label: 'Fiche', icon: FileText, color: 'bg-blue-100 text-blue-700' },
  video: { label: 'Vidéo', icon: Video, color: 'bg-red-100 text-red-700' },
  podcast: { label: 'Podcast', icon: Headphones, color: 'bg-green-100 text-green-700' },
  tool: { label: 'Outil', icon: FileText, color: 'bg-amber-100 text-amber-700' }
};

export const ResourceCard = ({ resource }) => {
  const config = resourceTypeConfig[resource.resource_type] || resourceTypeConfig.tool;
  const Icon = config.icon;

  return (
    <Link to={`/resources/${resource.resource_id}`} data-testid={`resource-card-${resource.resource_id}`}>
      <Card className="h-full hover:shadow-md transition-shadow duration-300 cursor-pointer group">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between mb-2">
            <Badge className={`text-xs ${config.color} border-0`}>
              <Icon className="w-3 h-3 mr-1" />
              {config.label}
            </Badge>
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Download className="w-3 h-3" />
              {resource.downloads}
            </div>
          </div>
          <CardTitle className="font-serif text-lg leading-tight group-hover:text-primary transition-colors line-clamp-2">
            {resource.title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {resource.thumbnail_url && (
            <div className="aspect-video rounded-md overflow-hidden mb-4 bg-muted">
              <img 
                src={resource.thumbnail_url} 
                alt={resource.title}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          
          <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
            {resource.description}
          </p>
          
          {resource.tags && resource.tags.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {resource.tags.slice(0, 3).map((tag, idx) => (
                <span key={idx} className="text-xs px-2 py-0.5 bg-muted rounded-full text-muted-foreground">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </Link>
  );
};
